import { NylasSchedulerConfigStoreType } from '@/stores/scheduler-config-store';
import { NylasSchedulerStoreType } from '@/stores/scheduler-store';
import { NylaSchedulerAPIConnector } from './shared/api/scheduler';
import { NylasSchedulerConfigAPIConnector } from './shared/api/scheduler-config';

export interface BaseNylasConnectorInterface {
  resetStores(): void;
  init(): void;
}

export interface NylasSchedulerConnectorInterface extends BaseNylasConnectorInterface {
  schedulerAPIURL: string;
  nylasSchedulerStore: NylasSchedulerStoreType;
  get schedulerStore(): NylasSchedulerStoreType;
  get scheduler(): NylaSchedulerAPIConnector;
}

export interface NylasSchedulerConfigConnectorInterface extends BaseNylasConnectorInterface {
  nylasSchedulerConfigStore: NylasSchedulerConfigStoreType;
  get schedulerConfigStore(): NylasSchedulerConfigStoreType;
  get schedulerConfig(): NylasSchedulerConfigAPIConnector;
}

export interface NylasConnectorInterface extends NylasSchedulerConnectorInterface {}
